import { render, staticRenderFns } from "./IInvalidLink.vue?vue&type=template&id=359c9a9c&scoped=true&"
import script from "./IInvalidLink.vue?vue&type=script&lang=js&"
export * from "./IInvalidLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c9a9c",
  null
  
)

export default component.exports